import jsPDF from 'jspdf';
// Side-effect import to register autoTable plugin
import 'jspdf-autotable';

/**
 * Export table data to PDF file
 * @param {Array} data - Array of objects containing table data
 * @param {Array} columns - Array of column definitions with { key, label }
 * @param {String} fileName - Name of the PDF file (without extension)
 */
export const exportToPDF = (data, columns, fileName = 'export') => {
  try {
    // If no data, show alert
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }

    // Create new PDF document in portrait mode
    const doc = new jsPDF('portrait', 'mm', 'a4');
    const margin = 10;

    // Prepare table data with separate serial numbers for total rows and model rows
    let totalRowCounter = 0;
    let modelRowCounter = 0;
    
    const tableData = data.map((row, index) => {
      let srNo;
      
      // Check if this is a total row
      if (row.is_total === true || row.model_name === "-") {
        totalRowCounter++;
        srNo = totalRowCounter;
      } else {
        // Model rows - continuous numbering across all dates
        modelRowCounter++;
        srNo = modelRowCounter;
      }
      
      const rowData = [srNo]; // Sr No
      
      columns.forEach((column) => {
        const value = row[column.key];
        rowData.push(value !== null && value !== undefined ? String(value) : '-');
      });
      
      return rowData;
    });

    // Prepare table headers
    const headers = ['Sr No', ...columns.map(col => col.label)];

    // Add simple title - format title for display
    let displayTitle = 'Profit Report';
    if (fileName && fileName.startsWith('ProfitReport')) {
      displayTitle = 'Profit Report';
    } else if (fileName) {
      displayTitle = fileName;
    }
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(displayTitle, margin, 15);
    
    // Add date
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Date: ${new Date().toLocaleDateString()}`, margin, 22);

    // Add basic table
    doc.autoTable({
      head: [headers],
      body: tableData,
      startY: 28,
      styles: {
        fontSize: 9,
        cellPadding: 2,
        halign: 'left',
      },
      headStyles: {
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 9,
      },
      margin: { top: 28, left: margin, right: margin },
      didParseCell: function (hookData) {
        // Skip header rows
        if (hookData.section === 'head') {
          return;
        }
        const rowIndex = hookData.row.index;
        if (rowIndex >= 0 && rowIndex < data.length) {
          const rowData = data[rowIndex];
          if (rowData && (rowData.is_total === true || rowData.model_name === "-")) {
            hookData.cell.styles.fillColor = [255, 255, 0];
            hookData.cell.styles.fontStyle = 'bold';
          }
        }
      },
    });

    // Save PDF
    doc.save(`${fileName}_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    alert('Failed to export data to PDF. Please try again.');
  }
};

/**
 * Export filtered table data to PDF
 * @param {Array} filteredData - Filtered array of objects
 * @param {Array} columns - Array of column definitions
 * @param {String} fileName - Name of the PDF file
 */
export const exportFilteredToPDF = (filteredData, columns, fileName = 'export') => {
  exportToPDF(filteredData, columns, fileName);
};
